import { createSlice } from '@reduxjs/toolkit';
import { primaryColor } from '../../utils/constants';

interface AppState {
    theme: any;
    user: any;
    status: 'idle' | 'loading' | 'failed' | 'succeeded';
}

const initialTheme = {
    primaryColor: primaryColor,
    mode: "light",
};


const initialState: AppState = {
    theme: { ...initialTheme },
    user: {},
    status: 'idle',
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {},
    extraReducers: (_builder) => {

    },
});

export const { } = appSlice.actions;

export default appSlice.reducer;
